import { fg } from '@confluence/feature-gating';
import { FORGE_MODULE_XEN_MACRO } from '@confluence/forge-ui/entry-points/ForgeModuleType.ts';
import { preloadUseExtensionList } from '@confluence/forge-ui/entry-points/preloadUseExtensionList.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';

export const preloadPdfExportRoute = async (match: RouteMatch): Promise<void | any[] | Error[]> => {
	const tasks: Promise<any>[] = [];

	const { contentId, spaceKey } = match.params;

	// Preload the Forge extension list so that window.__SSR_FORGE_EXTENSIONS__ is populated
	// before ForgeMacro mounts. Without this, ForgeMacro's isStaticExtension() check returns
	// false (the extension list query hasn't resolved yet), causing it to skip subscribing to
	// the store and render the iframe fallback instead of the static HTML from confluence_staticMacros.
	// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
	if (contentId && fg('conf_frontend_forge_static_macro_mvp')) {
		tasks.push(
			preloadUseExtensionList({
				contentId,
				spaceKey,
				moduleType: FORGE_MODULE_XEN_MACRO,
			}),
		);
	}

	return waitForAllReturnWhenError(tasks);
};
